import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop'
import {
	Component,
	EventEmitter,
	input,
	Input,
	inject,
	Optional,
	Output,
	ViewChild,
} from '@angular/core'
import { MatTable } from '@angular/material/table'
import { Parameter } from '@lg/shared'
import { calculateNextFreeName } from '@lg/shared'
import { AbstractEditorComponent } from '../../abstract-editor.component'
import { BusinessObject } from '@lg/shared'
import {
	ServiceProviderMethodParameter,
	ServiceProviderMethodParameterTypes,
} from '@lg/shared'
import { Class } from '@lg/shared'
import { AbstractEditorComponentInjectionToken } from '../../../injection-tokens'

@Component({
	selector: 'lowgile-parameters',
	templateUrl: './parameters.component.html',
	styleUrls: ['./parameters.component.scss'],
	standalone: false,
})
export class ParametersComponent {
	@Input() parameters: Parameter[] = []
	@Input() typeDeclarations: string
	@Output() parametersUpdated = new EventEmitter<void>()
	parameterClass = input<Class<Parameter>>(Parameter)

	@ViewChild('table') table: MatTable<Parameter>
	colNames = ['actions', 'name', 'type']
	readonly parameterTypes = Object.entries(ServiceProviderMethodParameterTypes)
	public boEditor = inject(AbstractEditorComponentInjectionToken)

	constructor() {}

	addParameter() {
		const parameterClass = this.parameterClass()
		this.parameters.push(
			new parameterClass({
				name: calculateNextFreeName('input', this.parameters, (p) => p.name),
				type: 'string',
			}),
		)
		this.onChange()
	}

	removeParameter(idx: number) {
		this.parameters.splice(idx, 1)
		this.onChange()
	}

	onDropListDropped(event: CdkDragDrop<any, any>) {
		if (event.previousIndex == event.currentIndex) return

		moveItemInArray(
			event.previousContainer.data,
			event.previousIndex,
			event.currentIndex,
		)
		this.onChange()
	}

	onChange() {
		console.log('update')
		this.parametersUpdated.emit()
		this.table.renderRows()
	}

	isServiceProviderMethodParameter(
		parameter: Parameter,
	): parameter is ServiceProviderMethodParameter {
		return parameter instanceof ServiceProviderMethodParameter
	}
}
